module.exports = __webpack_public_path__ + "static/media/404.9d1fc51c.png";